import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface GoBackButtonProps {
  label?: string;
  sx?: object;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({ 
  label = 'Go Back',
  sx = {}
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleGoBack}
      startIcon={<ArrowBackIcon />}
      sx={{
        color: '#64748b',
        borderColor: '#e2e8f0',
        fontWeight: 600,
        px: 3,
        py: 1,
        '&:hover': {
          backgroundColor: '#f8fafc',
          borderColor: '#cbd5e1'
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default GoBackButton;
